// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kpaB0","right":"styles_right__1M9lE"};